(function() {
  angular.module('registration')
  .controller('dsoRegistrationController', ['$scope','States', 'dsoRegistrationService', 'DsoProfile', '$state', '$log',
    function($scope, States, dsoRegistrationService, DsoProfile, $state, $log) {
      var vm = this;
      vm.submit = submit;
      vm.reset = reset;
      vm.running = false;
      if (dsoRegistrationService.requestToken) {
        vm.model = dsoRegistrationService.init();
      }
      vm.model = dsoRegistrationService.dsoRegistrationModel();
      vm.regExp = /[^0-9]/g;
      if (vm.model && vm.model.taxIds) {
        vm.taxIds = _.map(vm.model.taxIds,'taxId');
      }

      $scope.$watch('errorControl', function() {
        $scope.errorControl && $scope.errorControl.showErrors('taxId');
      });

      function submit() {
        $scope.errorControl.showErrors();
        if ($scope.dsoRegistrationForm.$valid) {
          vm.running = true;
          vm.model.taxIds = [];
          _.each(vm.taxIds,(taxId) => {
              vm.model.taxIds.push({'taxId': taxId});
          });
          $log.debug("DSO", vm.model);
          dsoRegistrationService.dsoRegistrationModel(vm.model);
          let dsoProfile = angular.copy(dsoRegistrationService.dsoProfile());
          DsoProfile.save(dsoProfile).$promise.then((data) => {
            vm.running = false;
            vm.model.id = data.dsoId;
            dsoRegistrationService.dsoRegistrationModel(vm.model);
            $state.go('dsoRequestConfirmation');
          }, () => {
            vm.running = false;
          });
        }
      }

      function reset() {
        vm.model = dsoRegistrationService.dsoRegistrationModel({});
      }

    }]);
})();
